import { useSelector, useDispatch } from "react-redux";

export const getElementById = (id, formBuilder) => {
  return formBuilder
    .map((section) => {
      return section.elements.find((element) => element.instanceId === id);
    })
    .filter(Boolean);
};

export const CustomImage = ({ instanceId }) => {
  const dispatch = useDispatch();
  const formBuilder = useSelector((state) => state.customFormBuilder);

  const element = getElementById(instanceId, formBuilder)[0];
  const elementStyle = element?.style || {};

  const getContainerStyles = () => {
    return {
      padding: elementStyle.padding || "0",
      marginLeft: elementStyle.marginLeft || "0",
      marginRight: elementStyle.marginRight || "0",
      marginTop: elementStyle.marginTop || "0",
      marginBottom: elementStyle.marginBottom || "0",
      textAlign: elementStyle.alignment || "center",
      width: "100%", // Container should always be 100% width
    };
  };

  const getImageStyles = () => {
    return {
      width: elementStyle.width || "100%",
      height: elementStyle.height || "auto",
      maxWidth: elementStyle.maxWidth || "100%",
      borderRadius: elementStyle.borderRadius || "0",
      borderStyle: elementStyle.borderStyle || "none",
      borderColor: elementStyle.borderColor || "#ced4da",
      borderWidth: elementStyle.borderWidth || "0",
      objectFit: elementStyle.objectFit || "cover",
      opacity: elementStyle.opacity || "1",
      display: "block", // Add this to prevent inline spacing issues
      margin: elementStyle.alignment === "center" ? "0 auto" : "0", // Center the image if alignment is center
    };
  };

  const getPlaceholderStyles = () => {
    return {
      width: elementStyle.width || "100%",
      height: elementStyle.height || "auto",
      minHeight:
        elementStyle.height === "auto"
          ? "200px"
          : elementStyle.height || "200px",
      backgroundColor: elementStyle.backgroundColor || "#f8f9fa",
      borderRadius: elementStyle.borderRadius || "0.25rem",
      borderStyle: elementStyle.borderStyle || "solid",
      borderColor: elementStyle.borderColor || "#ced4da",
      borderWidth: elementStyle.borderWidth || "1px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      margin: elementStyle.alignment === "center" ? "0 auto" : "0", // Center if needed
    };
  };

  const getLabelStyles = () => {
    return {
      fontSize: elementStyle.labelFontSize || "16px",
      fontWeight: elementStyle.labelFontWeight || "bold",
      marginBottom: "0.5rem",
      color: elementStyle.labelColor || "#212529",
      display: "block",
    };
  };

  if (!element) {
    return <div>Image element not found</div>;
  }

  const imageUrl = elementStyle.imageUrl || "";
  const altText = elementStyle.altText || "Image";

  return (
    <div style={getContainerStyles()}>
      {/* {elementStyle.label?.label && (
        <label style={getLabelStyles()}>{elementStyle.label.label}</label>
      )} */}

      {imageUrl ? (
        <img src={imageUrl} alt={altText} style={getImageStyles()} />
      ) : (
        <div style={getPlaceholderStyles()}>
          <i className="bi bi-image fs-3 text-secondary mb-2"></i>
          <p className="small text-muted m-0">Image Placeholder</p>
        </div>
      )}
    </div>
  );
};
